"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MenuHeader = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var material_1 = require("@mui/material");
var MenuHeader = function (_a) {
    var sx = _a.sx, children = _a.children;
    return ((0, jsx_runtime_1.jsx)(material_1.Toolbar, { sx: __assign({ px: { xs: 6, md: 7 }, py: 4 }, sx), children: children }));
};
exports.MenuHeader = MenuHeader;
